module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iKhQIl/tc-custom/9781035825059.jpg?1718106146971",
      "alt": "This image is the cover for the book Wester Island"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wester Island\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In an unprecedented venture, the world’s richest man turns a remote island into a live social experiment and reality show. It attracts a diverse group pursuing extraordinary goals: private visionaries, scientists, and military figures, all operating beyond mainland constraints. As the world watches, global tensions escalate towards war. "), _c('br'), _vm._v("Key players include Bonita Apple in the communist camp, Samson Tunn from Space Force testing new technologies, and local Sevi Akonga striving to preserve the island’s heritage. From a mainland cave, Jonah Smith narrates these events as the world teeters on the brink of chaos, offering a riveting glimpse into ambition, power, and the fragility of societal order.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew McKenzie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrew grew up in rural Hawkes Bay on an orchard and his interest in music took him to Wellington where he lived for twelve years as a musician. He moved back to the family property to look after his mother in her later years and a publishing deal with Ford NZ for one of his songs allowed a year off work and the writing of Wester Island. This time included travel to Egypt and some of the book was written there.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0